import { createFileRoute } from "@tanstack/react-router";
import { AiKnowledgeSettings } from "@/features/settings/ai-knowledge";

export const Route = createFileRoute("/_app/settings/ai")({
  head: () => ({ meta: [{ title: "AI & knowledge · Settings · Malfak" }] }),
  component: AiKnowledgeSettings,
});
